import React, { useState } from "react";
import {
  Overlay,
  PopupContainer,
  Header,
  Title,
  CloseButton,
  Content,
  ShieldImage,
  GuideText,
  FaqButton,
  Footer,
  OutlineButton,
} from "./styles";

const STORAGE_KEY = "privacy-doc-popup-dismiss-date";
const PRIVACY_DOC_POPUP_DATE = "20260401";
const FAQ_URL =
  "https://goofy-may-2ac.notion.site/322d45253157809da7aad7810a4418ad";

const PrivacyDocPopup: React.FC = () => {
  const today = new Date().toISOString().slice(0, 10);
  const todayNum = today.replace(/-/g, "");
  const isExpired = todayNum > PRIVACY_DOC_POPUP_DATE;
  const dismissed = localStorage.getItem(STORAGE_KEY) === today;

  const [visible, setVisible] = useState(!isExpired && !dismissed);

  if (!visible) return null;

  const handleClose = () => {
    setVisible(false);
  };

  const handleDismissToday = () => {
    localStorage.setItem(STORAGE_KEY, today);
    setVisible(false);
  };

  return (
    <Overlay onClick={handleClose}>
      <PopupContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>개인정보처리 위탁 관련 서류 안내</Title>
          <CloseButton onClick={handleClose} aria-label="닫기">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </CloseButton>
        </Header>
        <Content>
          <ShieldImage
            src="/images/privacy_shield_blue.png"
            alt="개인정보 보호"
          />
          <GuideText>
            교육부 공문(학생건강정책과-1157)에 따라
            <br />
            스마일보건 사용 시 <strong>개인정보처리위탁 계약서</strong> 등
            <br />
            관련 서류를 안내드립니다.
          </GuideText>
          <FaqButton href={FAQ_URL} target="_blank" rel="noopener noreferrer">
            자세히 보기 (FAQ)
            <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
            </svg>
          </FaqButton>
        </Content>
        <Footer>
          <OutlineButton onClick={handleDismissToday}>
            오늘 하루 안보기
          </OutlineButton>
        </Footer>
      </PopupContainer>
    </Overlay>
  );
};

export default PrivacyDocPopup;
